/* stylelint-disable */
import { createGlobalStyle } from 'styled-components';
import { colorBlack900, mediaQueryMobileLargeMin } from './variables';

export const GlobalStyle = createGlobalStyle`
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  #root ::-webkit-scrollbar-track {
    background-color: #fff;
  }

  #root ::-webkit-scrollbar {
    height: 6px;
    width: 6px;
  }

  #root ::-webkit-scrollbar-thumb {
    background-color: #CACCCB;
    border-radius: 4px;
    max-height: 50px;
  }

  button {
    border: 0;
    background-color: rgba(0, 0, 0, 0);

    &:focus {
      outline: none;
    }
  }

  .InnerHTML {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      i {
        color: #df3014;
        font-style: normal;
      }
    }

    h1,
    h2,
    h3 {
      margin-bottom: 16px;

      @media (min-width: 640px) {
        margin-bottom: 24px;
      }
    }

    h4,
    h5,
    h6 {
      margin-bottom: 16px;
    }

    h1 {
      font-family: 'Raleway', sans-serif;
      font-size: 18px;
      line-height: 22px;
      font-weight: 700;
      color: ${colorBlack900};

      @media (min-width: 768px) {
        font-size: 24px;
        line-height: 28px;
      }

      @media (min-width: 1216px) {
        font-size: 30px;
        line-height: 36px;
      }
    }

    h2 {
      font-family: 'Raleway', sans-serif;
      font-size: 18px;
      line-height: 22px;
      font-weight: 700;
      color: ${colorBlack900};

      @media (min-width: 768px) {
        font-size: 22px;
        line-height: 26px;
      }

      @media (min-width: 1216px) {
        font-size: 24px;
        line-height: 28px;
      }
    }

    h3 {
      font-family: 'Raleway', sans-serif;
      font-size: 16px;
      line-height: 20px;
      font-weight: 700;
      color: ${colorBlack900};

      @media (min-width: 768px) {
        font-size: 18px;
        line-height: 22px;
      }

      @media (min-width: 1216px) {
        font-size: 22px;
        line-height: 26px;
      }
    }

    h4 {
      font-family: 'Raleway', sans-serif;
      font-size: 16px;
      line-height: 20px;
      margin: 0;
      font-weight: 700;
      color: ${colorBlack900};

      @media (min-width: 768px) {
        font-size: 18px;
        line-height: 22px;
      }
    }

    h5 {
      font-family: 'Raleway', sans-serif;
      font-size: 14px;
      line-height: 16px;
      font-weight: 700;
      color: ${colorBlack900};

      @media (min-width: 768px) {
        font-size: 16px;
        line-height: 18px;
      }

      @media (min-width: 1216px) {
        font-size: 16px;
        line-height: 20px;
      }
    }

    h6 {
      font-family: 'Raleway', sans-serif;
      font-size: 14px;
      line-height: 18px;
      font-weight: 700;
      color: ${colorBlack900};
    }

    & .grid-3col-container  {
      ul {
        width: 100%;
      }
      @media all and ${mediaQueryMobileLargeMin} {
        display: grid;
        gap: 8px;
        grid-template-columns: 1fr 1fr 1fr;
      }
    }

    & div.table-container {
      margin: 0 -16px 16px;
    }

    & div.table-container > div {
      overflow: auto;
    }

    & div.table-container > div > div {
      padding: 0 16px;
      min-width: 630px;
    }

    & table {
      border-collapse: collapse;
      border: 1px solid #e5e5e5;
      line-height: 20px;
      table-layout: unset;
      text-align: left;
      width: 100%;
      margin-bottom: 16px;

      @media (min-width: 640px) {
        margin-bottom: 24px;
      }

      thead {
        background-color: #f8fafb;
        font-weight: 700;
      }

      tr {
        width: 100%;
        &:not(:last-child){
          border-bottom: 1px solid #e4eaf4;
        }        

        td {
          padding: 16px;
          color: ${colorBlack900};
          min-width: 80px;
          border: none;
        }

        td:first-child {
          min-width: 40px;
        }

        th {
          padding: 16px;
          color: #575757;
          font-weight: normal;
        }
      }
    }

    & div.table-container table {
      margin-bottom: 0;
    }

    & hr {
      background: #fff;
      border: 0;
      border-top: 1px solid #e5e5e5;
      margin: 32px 0;
    }

    & > *:last-child {
      margin-bottom: 0;
    }

    & a {
      word-break: break-all;
      color: #244696;
    }

    & a.no-break {
      word-break: normal;
    }

    & p,
    & ul,
    & ol,
    & a {
      font-size: 14px;
      line-height: 24px;

      @media (min-width: 640px) {
        font-size: 16px;
        line-height: 28px;
      }
    }

    & p,
    & ul,
    & ol {
      margin-bottom: 16px;

      @media (min-width: 640px) {
        margin-bottom: 24px;
      }
    }

    & ul > li::before {
      content: '•';
      color: ${colorBlack900};
      margin-right: 8px;
    }

    & ul.dashed-list > li:before {
      content: '-';
      color: ${colorBlack900};
      margin-right: 2px;
    }

    & ol {
      counter-reset: my-counter;
      list-style: none;
      padding-left: 0;
    }

    & ol > li {
      margin: 0 0 0.5rem 0;
      counter-increment: my-counter;
      position: relative;
      color: ${colorBlack900};
    }

    & ol > li::before {
      content: counter(my-counter) '.';
      color: #95a4ac;
      font-size: 16px;
    }

    & ol > li > p,
    & ul > li > p {
      display: inline;
      margin: 0;
    }

    & ol.normal-arabic-list {
      list-style-type: decimal;
    }

    & ol.normal-arabic-list > li {
      position: static;
    }

    & ol.normal-arabic-list > li:before {
      content: '';
      display: none;
    }

    & p:has(+ ul) {
      margin-bottom: 16px;
    }

    & img {
      display: block;
      max-width: 100%;
    }

    & blockquote {
      font-size: 18px;
      line-height: 32px;
      padding: 32px;
      width: 100%;
      background-color: #fdf5f3;
      margin-bottom: 16px;
      color: #000;
      border-radius: 2px;
      border-left: 4px solid #df3014;

      @media (min-width: 640px) {
        padding: 40px;
      }
    }
    
    & p.footer-text {
      text-align: center;
      font-size: 12px;
      line-height: 17px;
      color: #93a4ac;
      margin: 0;

      @media (min-width: 640px) {
        text-align: start;
      }
    }

    & div.iframe-container {
      position: relative;
      padding-bottom: 56.25%;
      width: 100%;

      iframe {
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        position: absolute;
      }
    }

    & p.list-item {
      display: flex;

      span:first-child {
        margin-right: 8px;
      }
    }
  }

  body {
    background-color: #e9ebee;
  }

  @keyframes lazyload {
    0% {
      background-position: 100% 50%;
    }
  }

  body[header-styles-loading] {
    header.header {
      position: relative;
      z-index: 1;
      width: 100%;
      height: 56px;
      overflow: hidden;

      &::after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, #f2f3f5 19%, #fafafa 31%, #fafafa 69%, #f2f3f5 81%);
        background-size: 400% 400%;
        animation: lazyload 1s linear infinite;
      }

      @media (min-width: 960px) {
        height: 175px;
      }

      > * {
        display: none;
      }
    }
  }

  body[footer-styles-loading] {
    footer.footer {
      position: relative;
      z-index: 1;
      width: 100%;
      height: 300px;
      overflow: hidden;

      &::after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, #f2f3f5 19%, #fafafa 31%, #fafafa 69%, #f2f3f5 81%);
        background-size: 400% 400%;
        animation: lazyload 1s linear infinite;
      }

      > * {
        display: none;
      }
    }
  }

  .header,
  .footer,
  main {
    max-width: 1100px;
    width: 100%;
    margin: 0 auto;
  }

  main {
    position: relative;
    background: #fff;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-left: 20px;
    padding-right: 20px;
    margin-top: 2px;
  }

  @media only screen and (max-width: 800px) {
    main {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
`;
